<template>
  <div class="fabric-library">
    <rCenterHeader :list="headerMenu">
      <div slot="search">
        <form>
          <Input
            size="large"
            v-model="params.fabricCode"
            search
            @keydown.enter.native.prevent="search"
            @on-click="search"
            icon="ios-search"
            :placeholder="$t('fabricLibrary.search')"
            style="width: 380px; color: #081938"
          />
          <Button @click="filter" class="filter" size="large" type="primary">
            <span class="iconfont iconshaixuan"></span>
            {{ $t("fabricLibrary.filter") }}
          </Button>
        </form>
      </div>
    </rCenterHeader>
    <div class="fabric-list">
      <!-- <div class="filter-choose common-flex common-flex-wrap">
        <div
          class="common-flex common-align-center"
          v-for="(item, index) in filterChoose"
          :key="index"
        >
          <div class="filter-name">
            {{ item.name }}
          </div>
          <div class="iconfont iconguanbi common-hover"></div>
        </div>
      </div> -->
      <div class="common-flex common-flex-wrap" style="position: relative">
        <rFabric
          @fabric="fabric"
          :index="index"
          v-for="(item, index) in fabricList"
          :config="item"
          :key="index"
          :style="[(index + 1) % 10 == 0 ? {} : { marginRight: '11px' }]"
        ></rFabric>
        <Spin size="large" fix v-if="spinShow"></Spin>
      </div>
      <div
        v-if="!spinShow"
        class="common-flex common-justify-center"
        style="margin-top: 20px"
      >
        <Page
          :total="total"
          :current="params.pageNum"
          @on-change="changePage"
          :page-size="params.pageSize"
          show-total
        >
          <span>{{ $t("total") }} {{ total }} {{ $t("recoprds") }}</span>
        </Page>
      </div>
    </div>
    <rPreviewImg
      @pro="pro"
      @next="next"
      :ck="previewMsg.ck"
      :previewIndex="previewIndex"
      :previewShow="previewShow"
      :previewMsg="previewMsg"
      @handlerPreviewShow="handlerPreviewShow"
    ></rPreviewImg>
    <!-- 搜索项 -->
    <rFabricFilter
      :params="params"
      @search="search"
      @close="closeFilte"
      :filteShow="filteShow"
    ></rFabricFilter>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import rCenterHeader from "../../components/r-center-header";
import rFabric from "../../components/r-fabric";
import rPreviewImg from "../../components/r-preview-img";
import rFabricFilter from "../../components/r-fabric-filter";

export default {
  name: "fabric-library",
  data() {
    return {
      spinShow: false,
      filteShow: false,
      total: 0,
      params: {
        pageSize: 50,
        pageNum: 1,
        category: "", //产品分类
        fabricCode: "", //面料编码
      },
      // 预览信息
      previewMsg: "",
      // 当前预览索引
      previewIndex: 0,
      fabricList: [], //面料列表
      value: "",
      // 预览图片
      previewShow: false,
      // 头部面包屑
      headerMenu: [
        {
          name: this.$t("customer.crumbs.individualAccount"),
          to: "./user",
        },
        {
          name: this.$t("customer.crumbs.fabricLibrary"),
        },
      ],
      // 选择的分类
      filterChoose: [],
    };
  },
  components: {
    rCenterHeader,
    rFabric,
    rPreviewImg,
    rFabricFilter,
  },
  mounted() {
    this.getFabric();
  },
  methods: {
    ...mapActions([
      "fabricAction", //面料列表
      "fabricStockAction",//面料库存
    ]),
    // 上一个
    pro(e) {
      if (this.previewIndex > 0) {
        this.previewIndex = this.previewIndex - 1;
        this.fabric(this.fabricList[this.previewIndex], this.previewIndex)
      }
    },
    // 下一个
    next(e) {
      if (this.previewIndex < this.fabricList.length) {
        this.previewIndex = this.previewIndex + 1;
        this.fabric(this.fabricList[this.previewIndex], this.previewIndex)
      }
    },
    // 修改页码
    changePage(e) {
      console.log(e);
      this.params.pageNum = e;
      this.getFabric();
    },
    filter() {
      this.filteShow = true;
    },
    // 搜索
    search(e) {
      // if (e) {
      //   this.params = e;
      // }
      // console.log(11)
      this.filteShow = false;
      this.params.pageNum = 1;
      this.getFabric();
    },
    // 关闭搜索
    closeFilte() {
      this.filteShow = false;
    },
    // 获取面料
    getFabric() {
      let that = this;
      this.spinShow = true;
      this.fabricAction(this.params)
        .then((res) => {
          console.log("res", res);
          this.total = res.total;
          this.fabricList = res.data;
        })
        .finally(function () {
          console.log("结束");
          that.spinShow = false;
        });
    },
    // 查看面料
    fabric(e, index) {
      let that = this;
      that.spinShow = true;
      this.fabricStockAction({fabricCode: e.fabricCode})
        .then((res) => {
          that.previewMsg = e;
          that.previewMsg['ck'] = res.data;
          that.previewIndex = index;
        })
        .finally(function () {
          that.spinShow = false;
          that.previewShow = true;
        });
    },
    // 关闭弹框
    handlerPreviewShow() {
      this.previewShow = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.fabric-library {
  font-family: Roboto;

  .filter {
    background: #f8f8f8;
    border: none;
    color: #081938;
    margin-left: 5px;
    width: 85px;
    font-size: 14px;
  }

  .fabric-list {
    padding: 20px;
    background: #fff;
    width: 1420px;
    margin: 0 auto;
    min-height: 100vh;
    padding: 30px;
  }

  .filter-choose {
    margin-bottom: 25px;

    > div {
      padding: 8px 10px 8px 16px;
      background-color: #e6edf9;
      color: #0a4dcc;
      font-size: 12px;
      margin-right: 8px;
      border-radius: 3px;
      margin-bottom: 5px;
    }

    .filter-name {
      font-weight: 600;
      margin-right: 28px;
    }

    .iconguanbi {
      font-size: 12px;
      transform: scale(0.5);
      color: #081938;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/fabricLibrary/fabricLibrary.vue